module.exports = __webpack_public_path__ + "static/media/pterodactyl.265cf8e7.svg";